<template>
  <div class="nav-header">
    <div class="container">
      <!-- 左侧 -->
      <div class="n-l">
        <!-- 左侧logo -->
        <div class="n-logo">
          <!-- <img src="/imgs/1.png" alt="" /> -->
        </div>
        <h2>北京安吉迈医疗科技有限公司 </h2>
        <!-- 中间导航 -->
        <div class="n-list">
          <a href="javascript:;" @click="goHome()">首页</a>
          <a href="javascript:;" @click="goAc1()">行业资讯</a>
          <!-- <a href="/#/ac2">装修资讯</a> -->
          <!-- <a href="/#/ac3">家居资讯</a> -->
          <a href="javascript:;" @click="goInfo()">关于我们</a>
          <!-- <a href="/#/ac3">用户权益保证措施</a> -->
        </div>
      </div>
      <!-- 右侧 登录注册 -->
      <div class="n-login" >
        <span class="n-login" @click="goLogin()" v-show="this.LoggedShow">
          <i class="iconfont icon-denglu"></i>
          登录
        </span>

        <span class="n-login" @click="goReg()" v-show="this.LoggedShow">
          <i class="iconfont icon-zhuce"></i>
          注册
        </span>
        <!-- 用户名 -->
        <span class="n-info" v-show="!this.LoggedShow" v-text="this.nv_user.Username"
          ><i class="iconfont icon-denglu"></i
        ></span>

        <!-- 退出登录 -->
        <span class="n-info" @click="tolg()" v-show="!this.LoggedShow">
          <i class="iconfont icon-tuichudenglu"></i>
          退出登录
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
    document.title = "上海乐居好房信息服务有限公司";

    // alert(this.state);
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },

    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goReg() {
      this.$router.push("/register");
    },

    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
      // this.$forceUpdate()
    },

    // 跳转 文职管理岗
    goAc1() {
      this.$router.push("/ac1");
    },
    // 跳转 文职技能岗
    goAc2() {
      this.$router.push("/ac2");
    },

    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 首页跳转
    goHome() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.nav-header {
  width: 100%;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 10;
  // background-color: pink;
  .container {
    height: 100%;
    @include flex();
    // 左侧
    .n-l {
      height: 100%;
      display: flex;
      align-items: center;
      // logo
      .n-logo {
        width: 80px;
        height: 80px;
        margin-right: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      h2 {
        margin-right: 60px;
      }
      // 导航
      .n-list {
        a {
          font-size: 16px;
          margin: 0 15px;
          color: #7b838b;
          font-weight: 500;
          transition: all 0.3s;
          &:hover {
            color: rgb(16, 224, 187);
          }
          &:nth-child(1) {
            color: rgb(16, 224, 187);
            font-weight: bold;
          }
        }
      }
    }
    // 右侧
    .n-login {
      span {
        font-size: 16px;
        margin: 0 15px;
        border: 1px solid rgb(16, 224, 187);
        width: 80px;
        height: 30px;
        line-height: 30px;
        display: inline-block;
        padding: 5px;
        text-align: center;
        border-radius: 20px;
        cursor: pointer;
        transition: all 0.3s;
        &:hover {
          background-color: rgb(16, 224, 187);
          color: #fff;
        }
        i {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
